export default "__VITE_ASSET__P55Ngo21__"